
  export const common =  {
    '请求延时': '请求延时',
    '操作成功': '操作成功',
    '暂无数据': '暂无数据',
    '请输入': '请输入',
    'copyok': '复制成功',
    'copyerror': '复制失败',
  };

 export const tableList = {
    '持仓': '持仓',
    '仓位': '仓位',
    '跟单交易量':'跟单交易量',
    '跟单总交易量':'跟单总交易量',
    '用户昵称':'用户昵称',
    '当前委托': '当前委托',
    '当前计划': '当前计划',
    '历史仓位': '历史仓位',
    '账单': '财务记录',
    '全部平仓': '全部平仓',
    '全部撤单': '全部撤单',

    '合约名称': '合约名称',
    '创建时间': '创建时间',
    '方向': '方向',
    '杠杆': '杠杆',
    '保证金': '保证金',
    '开仓价格': '开仓价格',
    '开仓均价': '开仓均价',
    '全仓风险率': '全仓风险率',
    '预估爆仓价': '预估爆仓价',
    '收益率': '收益率',
    '平仓价格': '平仓价格',
    '预计强平价': '预计强平价',
    '持仓数量': '持仓数量',
    '张': '张',
    风险率: '风险率',
    保证金率: '保证金率',
    预计止盈价: '预计止盈价',
    预计止损价: '预计止损价',
    浮动盈亏: '浮动盈亏',
    平仓盈亏: '平仓盈亏',
    盈亏: '盈亏',
    委托数量: '委托数量',
    委托价格: '委托价格',
    成交价格: '成交价格',
    成交均价: '成交均价',
    止盈价: '止盈价',
    止损价: '止损价',
    执行价: '执行价',
    触发条件: '触发条件',
    操作: '操作',
    手续费: '手续费',
    平仓类型: '平仓类型',
    类型: '类型',
    数量: '数量',

    逐仓做多: '逐仓做多',
    逐仓做空: '逐仓做空',
    全仓做多: '全仓做多',
    全仓做空: '全仓做空',
    永续合约: '永续合约',

    手动平仓: '手动平仓',
    市价平仓: '市价平仓',
    限价平仓: '限价平仓',
    止盈: '止盈',
    止损: '止损',
    手动撤销: '手动撤销',
    自动减仓: '自动减仓',
    强制减仓: '强制减仓',
    强制平仓: '强制平仓',
    资金不足系统撤单: '资金不足系统撤单',
    资金超限系统撤单: '资金超限系统撤单',
    撤单: '撤单',
    平仓: '平仓',
    更多: '更多',
    部分平仓: '部分平仓',
    反向开仓: '反向开仓',
    加仓: '加仓',
    一键平仓: '一键平仓',
    最新价: '最新价',
    体验金平仓: '24小时平仓',
    下单时间: '下单时间',
    交易类型: '交易类型',
    委托类型: '委托类型',
    成交类型: '成交类型',
    逐仓平多: '逐仓平多',
    逐仓开多: '逐仓开多',
    逐仓平空: '逐仓平空',
    逐仓开空: '逐仓开空',
    全仓平多: '全仓平多',
    全仓开多: '全仓开多',
    全仓平空: '全仓平空',
    全仓开空: '全仓开空',
    可平量为0: '可平量为0',
    激活价格: '激活价格',
    状态: '状态',
    未激活: '未激活',
    已激活: '已激活',
    回调率: '回调率',
    仓位ID: '仓位ID',
  };
  export const dialog = {
    前往设置: '前往设置',
    提示: '提示',
    确定: '确 定',
    取消: '取 消',
    确认要全部平仓吗: '请确认是否要以市价全部平仓，且撤销所有委托单?',
    确认要全部撤单吗: '确认要全部撤单吗？',
    确认要一键平仓吗: '确认要一键平仓吗？',
    确认要一键平仓: '确认一键平仓，且解除跟单关系?',
    确认要市价平仓吗: '确认要市价平仓吗？',
    确认要限价平仓吗: '确认要限价平仓吗？',
    需先设置总跟单账户:"需先设置总跟单账户，才能开启跟单",
    加仓: '加仓',
    不能为空: '不能为空',
    必须为数字值: '必须为数字值',
    数字不能小于等于0: '数字不能小于等于0',
    请输入正确的杠杆倍数: '请输入正确的杠杆倍数',
    无法切换仓位模式: '无法切换仓位模式',
    当前账户没有权限: '当前账户没有权限',
    swap001: '当前有持仓,无法切换仓位模式',
    需全部平仓后可重新设置:"持有跟单仓位时无法修改跟单金额及倍率，需全部平仓后可重新设置",
    按张数: '按张数',
    按金额: '按金额',
    按比例: '按比例',
    按价格: '按价格',
    张: '张',
    预计加仓金额: '预计加仓金额',
    预计加仓张数: '预计加仓张数',
    持仓数量: '持仓数量',
    开仓价格: '开仓价格',
    确认要反向开仓吗: '确认要反向开仓吗？',
    预计平仓金额: '预计平仓金额',
    预计平仓比例: '预计平仓比例',
    预计平仓张数: '预计平仓张数',
    比例不可以大于: '比例不可以大于',
    比例不可以小于: '比例不可以小于',
    部分平仓: '部分平仓',
    确认撤单吗: '确认撤单吗？',
    确认要平仓吗: '确认要平仓吗？',
    盈亏: '盈亏',
    当前止损价: '当前止损价',
    预估止损价: '预估止损价',
    亏损: '亏损',
    止损修改: '止损修改',
    止损比例: '止损比例',
    止损价格: '止损价格',
    当前盈利价: '当前盈利价',
    预估止盈价: '预估止盈价',
    收益: '收益',
    止盈修改: '止盈修改',
    止盈比例: '止盈比例',
    止盈价格: '止盈价格',
    请输入加仓数: '请输入加仓数',
    请输入金额: '请输入金额',
    请输入止盈价格: '请输入止盈价格',
    请输入止盈比例: '请输入止盈比例',
    请输入止损价格: '请输入止损价格',
    请输入止损比例: '请输入止损比例',

    'BTC/USDT账户模式': 'BTC/USDT账户模式',
    账户模式: '账户模式',
    调整仓位模式: '调整仓位模式',
    保证金模式: '保证金模式',
    仓位模式: '仓位模式',
    调整保证金模式: '调整保证金模式对USDT所有合约生效',
    调整仓位合并模式: '调整仓位合并模式对USDT所有合约生效',
    全仓模式: '全仓模式',
    仓位合并: '仓位合并',
    逐仓: '逐仓',
    全仓: '全仓',
    合仓: '合仓',
    分仓: '分仓',
    swap002:
      '逐仓模式下，用户可双向持仓，空头仓位与多头仓位风险独立计算。用户爆仓只会损失仓位保证金，用户主动平仓时，空头仓位与多头仓位分别产生的亏损及盈利，会立即结算到对应仓位的仓位保证金中。',
    全仓模式下所有仓位将共享合约账户的可用保证金:
      '全仓模式下所有仓位将共享合约账户的可用保证金，若发生强平，可能损失所有仓位和可用保证金。请注意持仓风险！',
    合仓提示: '',
    分仓提示: '',
    不再提示: '不再提示',

    biking合约用户使用协议: 'biking合约用户使用协议',
    综述:
      '<b>1.综述</b><br><br>' +
      '<span>' +
      '1.1永续合约(“本服务”)是“biking”推出的虚拟资产衍生品。由“biking”负责产品的设计管理和交易平台的运营服务。' +
      '为使用“biking”永续合约，您应当阅读并遵守《“biking”永续合约用户使用协议》(“本协议”)。请您务必审慎阅读、充分理解各条款内容，并选择接受或不接受本协议。' +
      '<br><br>' +
      '1.2除非您已阅读并接受本协议所有条款，否则您无权使用“biking”永续合约及其相应的服务。您接受本协议的行为，以及您使用本服务的行为即视为您已阅读并同意受本协议的约束。' +
      '</span>' +
      '<br><br>' +
      '<b>2. 使用本服务的资格</b>' +
      '<br><br>' +
      '<span>2.1 您了解并确认：' +
      '<br>' +
      '您已同意遵守“biking服务条款”，同时您有资格并且不被禁止使用其中定义的“服务”;' +
      '<br>' +
      '本协议与您所在国家或地区的法律没有冲突;' +
      '<br>' +
      '您是存入本服务的虚拟资产的合法所有者，并保证这些虚拟资产的来源是合法的。' +
      '<br><br>' +
      '2.2您了解使用本服务的风险，包括但不限于：' +
      '<br>' +
      '虚拟资产及其衍生品的高价格波动可能会在短时间内造成重大或全部损失；' +
      '</span>',
    我已阅读并同意上述协议: '我已阅读并同意上述协议',

    调整杠杆: '调整杠杆',
    杠杆倍数: '杠杆倍数',
    当前杠杆倍数最大可开: '当前杠杆倍数最大可开：',
    '当前仓位所需保证金：': '当前仓位所需保证金：',

    交易单位切换: '交易单位切换',
    成交类型切换: '成交类型切换',
    限价: '限价',
    市价: '市价',
    数字范围必须在: '数字范围必须在 1 到 100 之间',
    请输入平仓数: '请输入平仓数',
    请输入平仓比例: '请输入平仓比例',
    请输入整数: '请输入整数',
    以当前最优价格交易: '以当前最优价格交易',
    请输入格式正确的杠杆倍数: '请输入格式正确的杠杆倍数',
    杠杆倍数提示: '当前杠杆倍数较高，请注意风险。',
    下单二次确认: '下单二次确认',
    平仓二次确认: '平仓二次确认',
    下单确认: '下单确认',
    二次确认不展示: '不再提示(您可在“偏好设置”中重新启动)',
    切换交易单位: '切换交易单位',
    偏好设置: '偏好设置',
    仓位止盈止损: '仓位止盈止损',
    移动止盈止损: '移动止盈止损',
    止盈止损提示:
      '移动止盈止损用于仓位平仓，指的是当行情往利好的方向推进，为了保障交易者的收益，当行情在回调的情况下，将交易者设定好的委托提交至市场的策略委托。当市场的最新价格到达设置的激活价格时，订单被激活；当市场价格到达交易者设定该策略后最高（最低）价格的（1±回调幅度）后，即会触发委托成交，执行价格为最高（最低）价格的（1±回调幅度）。',
    最新成交价: '最新成交价',
    设置止盈: '设置止盈',
    设置止损: '设置止损',
    预计盈利: '预计盈利',
    预计亏损: '预计亏损',
    调整保证金: '调整保证金',
    增加: '增加',
    减少: '减少',
    最大: '最大',
    当前仓位保证金: '当前仓位保证金',
    最大可增加: '最大可增加',
    最大可减少: '最大可减少',
    调整后参考强评价: '调整后参考强平价',
    请输入保证金: '请输入保证金',
    强平价格: '强平价格',
    开仓数量: '开仓数量',
    计算: '计算',
    计算结果: '计算结果仅供参考',
    回调率: '回调率',
    请输入回调率: '请输入回调率',
    仓位数量: '仓位数量',
    激活价: '激活价',
    请输入激活价: '请输入激活价',
    激活做多提示: '做多方向需高于最新成交价',
    激活做空提示: '做空方向需低于最新成交价',
  };
  export const codeInfo = {
    永续合约: '永续',
    标记价格: '标记价格',
    指数价格: '指数价格',
    指数价格提示:
      '该合约的实时指数价格。此价格将参与用户持仓的预估爆仓价计算，可能与合约最新成交价格有所偏差，以避免价格操纵。',
    '24H最高': '24H最高',
    '24H最低': '24H最低',
    资金费率: '本期资金费率',
    距费用结算: '距离本期费用结算还有',
    我的赠金: '我的赠金',
  };
  export const panKou = {
    交易深度: '盘口',
    实时成交: '买卖盘',
    张: '张',
    保证金: '保证金',
    价格: '价格',
    数量: '数量',
    时间: '时间',
    累计: '累计',
  };
  export const placeOrder = {
    立即去玩:"立即去玩",
    全仓: '全仓',
    逐仓: '逐仓',
    杠杆: '杠杆',
    开多: '开多',
    开空: '开空',
    市价委托: '市价',
    限价委托: '限价',
    计划委托: '计划',
    价格: '价格',
    数量: '数量',
    限价: '限价',
    市价: '市价',
    止盈止损: '止盈止损',
    张: '张',
    开仓价: '开仓价',
    触发价: '触发价',
    执行价: '执行价',

    收益: '收益',
    按比例设置: '按比例设置',
    按价格设置: '按价格设置',
    亏损: '亏损',

    swap003: '买入/做多',
    swap004: '卖出/做空',
    买入: '买入',
    卖出: '卖出',
    做多: '做多',
    做空: '做空',
    可用: '可用',
    可做多: '可做多',
    可做空: '可做空',

    资产: '资产',
    持仓保证金: '持仓保证金',
    未实现盈亏: '未实现盈亏',
    净值: '净值',
    可用保证金: '可用保证金',
    账户余额: '账户余额',
    风险率: '风险率',

    合约信息: '合约信息',
    指数来源: '指数来源',
    合约面值: '合约面值',
    资金费率: '资金费率',
    最大杠杆: '最大杠杆',
    下单方向可开张数的: '下单方向可开张数的',

    立即注册: '注册',
    登录: '登录',
    swap005: '资产(永续合约)',
    登录以查看: '登录以查看',

    请输入数量: '请输入数量',
    请输入价格: '请输入价格',
    请输入限价: '请输入限价',
    请输入止盈止损: '请输入止盈止损',
    '止损率不能大于90%': '止损率不能大于90%',
    止损价格不能大于: '止损价格不能大于',
    开通合约账号: '开通合约账号',
    账号冻结: '账号冻结',
    '止盈率不能大于1000%': '止盈率不能大于1000%',
    请输入触发价: '请输入触发价',
    保证金: '保证金',
    体验金: '体验金',
    不使用体验金: '不使用体验金',
    查看详情: '查看详情',
    委托保证金: '委托保证金',
    币: '币',
    计算器: '计算器',
    划转: '划转'
  };
  export const codelist = {
    搜索: '搜索',
    全部: '全部',
    交易对: '交易对',
    最新价: '最新价',
    涨幅: '涨幅',
    自选: '自选',
    添加自选成功: '添加自选',
    取消自选成功: '取消自选',
  };
  export const merchandiser = {
    我的实盘: "我的实盘",
    与优秀的交易员共同赚钱:"与优秀的交易员共同赚钱",
    code_00051: "跟单社区",
    个人中心:'个人中心',
    更多服务:'更多服务',
    钱包: "钱包",
    衍生品:'衍生品',
    跟单设置:'跟单设置',
    跟单: '跟单',
    跟单提示: '数据每小时更新一次',
    我的跟单: '我的跟单',
    成为交易员: '成为交易员',
    综合排名: '综合排名',
    收益率: '收益率',
    近3周收益: '近3周收益',
    近3周胜率: '近3周胜率',
    总收益: '总收益',
    累计收益率: '累计收益率',
    累计跟随人数: '累计跟随人数',
    跟随中: '跟随中',
    AUM: 'AUM',
    当前跟谁: '当前跟随',
    搜索交易员: '搜索交易员',
    满员: '满员',
    申请成为交易员: '申请成为交易员',
    手机号: '手机号',
    邮箱: '邮箱',
    请输入邮箱: '请输入邮箱',
    邮箱错误: '请输入正确邮箱',
    请输入手机号: '请输入手机号',
    手机号错误: '请输入正确手机号',
    请输入正确数值: '请输入正确额度',
    申请交易员提示文案: '申请成为交易员带单，即可获取带单利润分成',
    跟单确认: '跟单确认',
    我已同意跟单协议: '我已阅读并同意跟单协议',
    跟单协议: '《跟单协议》',
    申请跟单提示文案: "本协议由您（以下称为“您”或“您的”）和币王订立。您访问、使用或币王平台或其下任何一家网站（wang.com）、移动应用程序提供的任何服务或者以下第4款进一步描述的、币王或其下任何一家隶属机构的网站提供的其他相关服务（以下统称为“本服务”），即表示您确认已经阅读、理解并接受本使用条款协议（以下简称为“本使用条款”）规定的所有条款和条件，以及我们在平台公布的隐私声明。此外，在使用本服务的部分功能时，您可能还需遵守适用于这些功能的附加条款和条件。",
    申请跟单提示文案1: "1.跟随交易员开单，有可能存在亏损风险。该风险由跟单用户自行承担；",
    申请跟单提示文案2: "2.币王平台支持跟随者使用逐仓模式跟单账户进行跟单，跟随者如需自主开仓可前往合约使用合约账户进行合约交易，该期间跟单账户不受影响。",
    申请跟单提示文案3: "3.跟随成功后，只对交易员新开仓的仓位进行跟随，已经持有的仓位不跟随；您可随时取消跟单，取消跟单不会对已跟随的订单进行平仓，您可选择手动平仓；",
    申请跟单提示文案4: "4.跟单期间，对跟单仓位进行调整将导致您脱离跟单模式；",
    申请跟单提示文案5: "5.跟随交易员平仓后产生盈利，该订单将分12%的盈利金额给带单交易员作为奖励。",
    申请跟单提示文案6: "6.跟随交易员下单，可能存在亏损风险，请谨慎选择，并注意风险控制并了解 跟单风险",
    申请跟单提示文案7: "7.当跟随的交易员订单被判定为违规交易取消交易员身份时，您将无法跟随开新的仓位，已跟随的仓位不受影响，但会随即脱离跟单模式。",
    申请跟单提示文案8: "8.交易员有权移除跟单用户，被移除后，您将无法跟随开新的仓位，已跟随的仓位不受影响。",
    搜索您的国家名或国家区号: '搜索您的国家名或国家区号',
    我已同意成为交易员: '我已同意成为交易员',
    请勾选: '请勾选',
    申请交易员失败提示: '您当前正在跟单中，暂不能申请成为交易员，请停止全部跟单后再申请。',
    我知道了: '我知道了',
    今日收益: '今日收益',
    累计收益: '累计收益',
    交易员分成: '交易员分成',
    待结算分成: '待结算分成',
    已结算分成: '已结算分成',
    当前跟单: '当前跟单',
    历史跟单: '历史跟单',
    我的交易员: '我的交易员',
    编辑: '编辑',
    平仓均价: '平仓均价',
    持仓均价: '持仓均价',
    开仓时间: '开仓时间',
    平仓时间: '平仓时间',
    预估暴仓价: '预估暴仓价',
    交易员: '交易员',
    详情: '详情',
    仓位ID: '仓位ID',
    空位提醒: '空位提醒',
    空位提醒内容: '该交易员带单人数已满，当交易员非满员状态时发送一次提醒',
    当前跟随: '当前跟随',
    跟随人数数据: '{v1}/{v2}人',
    跟随人数: '跟随人数',
    总权益: '总权益',
    带单合约: '带单合约',
    交易数据: '交易数据',
    交易笔数: '交易笔数',
    盈利笔数: '盈利笔数',
    亏损笔数: '亏损笔数',
    扛单比例: '扛单比例',
    平均扛单率: '平均扛单率',
    最大扛单率: '最大扛单率',
    订单: '订单',
    跟随者: '跟随者',
    跟随者收益: '跟随者收益',
    跟随用户: '跟随用户',
    跟随总额: '跟随总额',
    跟随收益: '跟随收益',
    交易员订单本金: '交易员订单本金',
    当前带单: '当前带单',
    历史带单: '历史带单',
    跟单数据统计: '跟单数据统计',
    不用了: '不用了',
    设置提醒成功: '设置提醒成功',
    我的带单: '我的带单',
    查看主页: '查看主页',
    利润分成比例: '利润分成比例',
    跟随交易员: '跟随交易员',
    仓位类型: '仓位类型',
    指定杠杆: '指定杠杆',
    请输入杠杆: '请输入杠杆',
    单笔倍率: '单笔倍率',
    单笔金额: '单笔金额',
    固定额度: '固定额度',
    请输入单笔金额1: '请输入不小于5U的固定金额',
    请输入单笔金额: '请输入单笔跟单金额{v1}～{v2}',
    请输入单笔倍率: '请输入跟单比例{v1}～{v2}',
    每次下单折合U: '每次开仓投入折合{v1}USDT的保证金',
    每次下单倍数: '每次下单数量是交易员下单数量的{v1}倍',
    倍率: '倍率',
    跟单本金: '跟单本金',
    总跟单保证金: '总跟单保证金',
    请输入跟单本金: '请输入跟单本金',
    资产账户: '资产账户{v1}USDT',
    合约账户: '合约账户{v1}USDT',
    风险控制: '风险控制',
    设置: '设置',
    保存: '保存',
    取消跟随: '取消跟随',
    移除跟随: '移除跟随',
    交易员保证金: '交易员保证金',
    请输入交易员保证金: '请输入交易员保证金',
    风险设置提示: '跟随此交易员的持仓本金到达此数值后，将不再跟随下单',
    关闭带单: '关闭带单',
    我的跟随者: '我的跟随者',
    带单设置: '带单设置',
    预计利润分成: '预计利润分成',
    利润分成: '利润分成',
    开启成功: '开启成功',
    开启失败: '开启失败',
    关闭成功: '关闭成功',
    关闭失败: '关闭失败',
    确认取消吗: '确认取消跟随吗？',
    条件一: '合约无持仓、当前委托、计划委托',
    条件二: '合约账户可用余额>={v}USDT',
    条件三: '合约无持仓',
    最大回撤: '最大回撤',
    平均持仓时间: '平均持仓时间',
    正在跟随: '正在跟随',
    历史跟随: '历史跟随',
    累计跟单: '累计跟单',
    累计分成: '累计分成',
    笔: '笔',
    上一页: '上一页',
    下一页: '下一页',
    返回: '返回',
    今日预估收益: '今日预估收益',
    账户权益: '账户权益',
    将账户权益展示在个人信息页面: '将账户权益展示在个人信息页面',
    带单本金: '带单本金',
    每次开仓均会展示带单本金: '每次开仓均会展示带单本金',
    隐藏挂单价:'隐藏挂单价',
    带单币对: '带单币对',
    入住时间: '入住时间',
    保存成功: '保存成功',
    取消成功: '取消成功',
    设置成功: '设置成功',
    跟单合约: '跟单合约',
    历史委托: '历史委托',
    成交数量: '成交数量',
    触发时间: '触发时间',
    开启带单: '开启带单',
    账户已冻结: '账户已冻结,请联系客服',
    审核中: '审核中',
    小时: '{v}小时',
    累计分润: '累计分润',
    今日预估分润: '今日预估分润',
    交易协议: '《交易协议》',
    带单协议: '《带单协议》',
    追加跟单本金: '追加跟单本金',
    提示: '提示：',
    提示信息: '分润每日0点开始结算并在1点前完成，结算后将自动发放至您的合约账户；如结算期间您有带单持仓，将在下一个交易日结算分润',
    合约跟单: '合约跟单',
    跟单文字: '在biking，与全球顶级交易员一起赚钱',
    查看牛人实盘: '查看牛人实盘',
    捕捉市场信号: '捕捉市场信号',
    复制高手收益: '复制高手收益',
    跟单指南: '跟单指南',
    跟单广场: '跟单广场',
    跟单总收益: '跟单总收益',
    丰厚分润收入: '丰厚分润收入',
    更多平台曝光: '更多平台曝光',
    专属交易徽章: '专属交易徽章',
    成为Biking带单交易员: '仅需一步，成为Biking带单交易员',
    享受Biking带单交易员的独家福利: '享受Biking带单交易员的独家福利',
    平台奖励: '享12%带单分润',
    联系方式: '联系方式',
    简介: '简介',
    请输入简介: '请输入简介',
    交易能力证明: '交易能力证明（可选）',
    选择周期: '请选择周期>30天的收益率曲线、交易数据统计等截图；若不上传，我们将默认审核您欧易交易记录。最多可上传 3 张图片，每张大小不超过 10 MB。',
    我已阅读并同意: '我已阅读并同意',
    跟单交易服务条款: '《跟单交易服务条款》',
    立即申请: '立即申请',
    请输入联系方式: '请输入联系方式',
    联系方式不正确: '联系方式不正确!',
    邮箱格式不正确: '邮箱格式不正确',
    请输入简介信息: '请输入简介信息',
    请确认勾选协议: '请确认勾选协议',
    上传头像图片限制: '上传头像图片大小不能超过 10MB!',
    最大限制: '当前最大限制上传3个文件',
    带单交易员招募中: '带单交易员招募中，即刻尊享12%带单分润',
    跟单成功: '跟单成功',
    昵称: '昵称',
    请输入昵称: '请输入昵称',
    申请交易员已提交: '申请交易员已提交，请等待审核'
  };
  export const hyy = {
    bkt: "不开通",
    wqdkt: "我确定开通",
    kt12: "1.	您在参与之前务必详尽地了解数字货币合约交易的基本知识和相关风险以及参与衍生品交易所有关的业务规则等",
    kt13: "2.	本风险提示书上述风险事项仅为列举性质，未能详尽的列明有关数字资产衍生品交易的所有风险因素，投资者参与数字资产衍生品交易投资前，还应该认真对其它可能存在风险因素有所了解和掌握。",
    kt14: "3.	我们诚挚的希望和建议投资者，从风险承受能力等自身实际情况出发，审慎的决定是否参与此合约交易，合理地配置自己的数字资产。",
    kt0: "亲爱的用户：",
    kt1: "您尚未开通合约账户及合约交易权限，请您仔细阅读以下内容以后再决定是否开通：",
    kt2: "一、	您在合约市场进行交易，假如市场价格走势对您不利导致您的仓位保证金不足时，BiKing永续合约会按照系统约定对您的仓位进行强平委托并披露强平明细。",
    kt3: "二、	您必须认真阅读并遵守BiKing永续合约的业务规则，了解合约的机制和运行原理，了解市场的各种风险。",
    kt4: "四、	BiKing永续合约接入的是合约交易系统，用户仓位的盈亏随合约行情的波动而变化，当亏损较大时，亦会在合约交易系统中发生爆仓。请用户您及时根据合约行情自行决定自己的交易行为，自负盈亏，据此，BiKing不承担任何推定或者既定的保证责任。",
    kt5: "五、	在某些极端的市场情况下，您可能会难以或无法将持有的未平仓合约平仓。例如，当你的盈利在整个合约市场中有效杠杆PnL中排位第一，且对手盘在保险基金不足以垫付其穿仓损失的情况下。",
    kt6: "六、	数字资产衍生品交易可能面临一定法域内的政策监管风险，您在交易之前需在了解交易地域的政策监管背景的前提下审慎做出判断。由于相关国家及地区法律、法规、政策的变化、合约交易所交易规则的修改、紧急措施的出台等原因，BiKing会提前披露声明，您持有的未平仓合约可能无法继续持有，但保证金和盈利的结余仍会兑现",
    kt7: "七、	由于非平台方所能控制的原因，例如：地震、水灾、火灾等不可抗力因素或者计算机系统、通讯系统故障等，可能造成您的指令无法成交或者无法全部成交，由此导致的损失可能会由您自己承担。",
    kt8: "八、	 “套期保值”交易同投机交易一样，同样面临价格波动引起的风险。",
    kta9: "九、	如果您没有进行实名认证或者未绑定Google验证，或者将账号借给非本人操作，将可能会影响您的合约保证金的安全性",
    kta10:
      "三、 在某些极端的市场情况下，您可能会难以或无法将持有的未平仓合约平仓。例如，当你的盈利在整个合约市场中有效杠杆PnL中排位第一，且对手盘在保险基金不足以垫付其穿仓损失的情况下。",
    kt9: "我已仔细阅读，并愿意承担风险",
    kt10: "开通合约账号及合约交易权限",
    zjhz: "资金划转",
    ljhz: "立即划转",
    qx: "取消划转",
    khz: "可划转",
    qxz: "请选择",
    bz: "币种",
    c: "从",
    zz: "转至",
    sl: "数量",
    qb: "全部",
    ktcg: "开通成功",
    ktsb: "开通失败",
    hzcg: "划转成功",
    hzsb: "划转失败",
    wyyd: "", //未勾选已经阅读提示文案
    tc: "退出",
    warning1: "请选择币种",
    warning2: "转出账户不能为空",
    warning3: "转入账户不能为空",
    warning4: "请输入不大于可转数量的数字",
    gb: "关闭",
    openSuccess: "您已开通合约交易",
    openSuccessTip: "请划转资金到合约账户",
    warning5: "最大保留4位小数",
    not_get_nm: "抱歉，泥码活动已发放结束，本次划转未能获得泥码",
  }

  export const invite = {
    yqfy: "邀请返佣",
    yj1: "分享邀请链接、邀请海报或推荐码",
    yj2: "邀请朋友注册并交易",
    yj3: "坐享交易手续费返佣",
    yqm: "我的邀请码：",
    yqlj: "我的邀请链接：",
    fz: "复制",
    fzcg: "复制成功",
    fzsb: "复制失败",
    dlck: "登录后查看",
    rs: "已邀请人数",
    ljbb: "累计币币交易返佣({flag}）",
    ljeft: "累计ETF交易返佣({flag}）",
    ljhy: "累计合约交易返佣({flag}）",
    yhm: "用户名",
    sfsm: "是否实名",
    tjsj: "推荐时间",
    zsy: "总收益({flag}）",
    s: "是",
    f: "否",
    djjz: "点击加载更多",
    ckmx: "查看详情",
    pm: "排名",
    zyqr: "月邀请人数",
    zfyj: "月返佣金额({flag}）",
    ckbd: "查看完整榜单",
    rlues1: "邀友注册，长期返佣，坐享收益。",
    rlues2:
      "邀请好友注册即可建立邀请关系，好友进行币币、杠杆ETF交易可获得好友手续费返佣，邀请返佣收益无上限。",
    rlues3: "邀请返佣规则&比例",
    jylx: "交易类型",
    yqrfy: "邀请人返佣",
    yqgxyxq: "邀请关系有效期",
    sixMonth: "6个月",
    yj: "永久",
    bbjy: "币币交易",
    hyjy: "合约交易",
    etfjy: "杠杆ETF交易",
    gxsj: "每周一更新数据",
    xts: "小贴士",
    ts1: "好友注册时必须填写您的邀请码，方视作你的成功邀请哦！",
    ts2: "用手机扫描左边二维码，链接转发给用户，可以快速邀请用户。",
    tgzsy: "推广总收益({flag}）",
    cz: "操作",
    fymx: "返佣明细 >",
    zwsj: "暂无记录",
    yh: "用户",
    hqyj: "获得邀请返佣金",
    ysm: "已实名",
    wsm: "未实名",
    hyfymx: "好友返佣明细",
    fylx: "返佣类型",
    fyje: "返佣金额",
    fysj: "返佣时间",
    mxsyb: "明细收益表",
    zwjy: "该好友暂未交易，无手续费返佣",
    bczxc: "保存至相册",
    rlues4: "受网络波动影响，部分用户会出现佣金延迟到账的情况，请耐心等待。",
    moreRules: "查看详细规则",
  };
  



// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/zh.js